module.exports = __webpack_public_path__ + "img/adfweertwrt3345143551jkhkjhfaodif.b03da93e.png";